import $ from 'jquery';
import { isLocalStorageSupported } from '../../utils';

export const setupFilters = body => {
  const $body = $(body);
  const $collapsableFilter = $body.find('.collapsable-filter');

  if ($collapsableFilter.length === 0) {
    return;
  }

  // There are two collapsable filters with counts: the category filter (which includes projects and categories),
  // and the custom field filter (which is just custom field options).
  const countsLoaded = { category: false, customField: false };

  // For saving expand/collapse state per filter per portal. So the key includes
  // the portal id and the filter container id (custom field or category).
  const localStorageKey = container => {
    const portalId = $body.find('meta[name="idea-portal-id"]').attr('content');
    return `portal-${portalId}-${container.attr('id')}-state`;
  };

  // Derive project line counts as the sum of their descendant project counts
  const setProjectLineCounts = $container => {
    setTimeout(() => {
      $container.find('.count--project-line').each((_, element) => {
        const $this = $(element);

        $this.text(
          $this
            .closest('.category-filter-branch')
            .find('.count--project') // projects only, not lines, avoids double counting
            .toArray()
            .reduce((acc, el) => acc + parseInt($(el).text(), 10) || 0, 0)
        );
      });
    }, 200);
  };

  // Click to expand/collapse sidebar filter. For custom field filter and category filter.
  $collapsableFilter
    .find('.expand-collapse')
    .rebind('click.collapsable-filter', event => {
      const $container = $(event.target).closest('.collapsable-filter');
      const $toggle = $container.find('.expand-collapse');
      const $filters = $container.find('.filters');
      const containerId = $container.attr('id');
      const isCategoryFilter = containerId === 'category-filter';
      const filterType = isCategoryFilter ? 'category' : 'customField';
      const loadCountsUrl = $container.data('load-counts-url');

      $filters.toggleClass('hidden');
      const expanded = !$filters.hasClass('hidden');

      $toggle.find('i').toggleClass('fa-chevron-down fa-chevron-right');
      $toggle.attr('aria-expanded', expanded);

      // Lazy load the counts on expand first time
      if (expanded && loadCountsUrl && !countsLoaded[filterType]) {
        let timer = setTimeout(() => {
          $container
            .find('.filter:not(.active):first .count')
            .html('<aha-spinner />');
        }, 500);

        $.get(loadCountsUrl).done(data => {
          clearTimeout(timer);
          countsLoaded[filterType] = true;
          $container.find('.count').empty();

          if (isCategoryFilter) {
            // Populate counts for category tree: project counts, category counts, and project line counts
            $.each(data.project_counts, function (id, count) {
              $container.find(`#project-${id} .count--project`).text(count);
            });
            $.each(data.category_counts, function (id, count) {
              $container
                .find(`#category-${id} .category-count:first`)
                .text(count);
            });
            setProjectLineCounts($container); // based on project counts established above
          } else {
            // Populate the custom field option counts
            $.each(data, function (id, count) {
              const selector = `#custom_field_option_${id} .cfo-count`;
              $container.find(selector).text(count);
            });
          }

          $container.find('.count:empty').text('0');
        });
      }

      // Save the expand/collapse state for this filter container
      if (isLocalStorageSupported()) {
        localStorage.setItem(
          localStorageKey($container),
          expanded ? 'expanded' : 'collapsed'
        );
      }
    });

  // Activate a sidebar filter (category filter or custom field filter). Shows it as active, and replaces
  // its count with a close icon.
  const activateFilter = selector => {
    const $filter = $body.find(selector);

    if ($filter.length > 0) {
      $filter.find('.filter:first').addClass('active');
      $filter.find('.aha-icon-close:first').removeClass('hide');
      $filter.find('.count:first').addClass('hide');
    }
  };

  // On page load, activate the selected filter, and auto-expand the filter container.
  // For custom field filter and category filter.
  $.each($collapsableFilter, (_, container) => {
    const $container = $(container);
    const filteredProjectId = $container.data('filtered-project-id');
    const filteredCategoryId = $container.data('filtered-category-id');
    const filteredCfoId = $container.data('filtered-cfo-id');

    // Each container can have at most one active filter. The category filter container can be filtered
    // by project or category. The custom field filter container can be filtered by custom field option.
    activateFilter(
      filteredProjectId
        ? `#project-${filteredProjectId}`
        : filteredCategoryId
        ? `#category-${filteredCategoryId}`
        : filteredCfoId
        ? `#cfo-${filteredCfoId}`
        : null
    );

    const isCollapsed = $container.find('.filters').hasClass('hidden');
    const hasActiveFilter = $container.find('.filter.active').length > 0;
    const state = isLocalStorageSupported()
      ? localStorage.getItem(localStorageKey($container))
      : null;
    const isCategoryFilter = $container.attr('id') === 'category-filter';
    const shouldBeExpanded =
      state === 'expanded' ||
      hasActiveFilter ||
      (isCategoryFilter && state === null);

    if (isCollapsed && shouldBeExpanded) {
      $container.find('.expand-collapse').click();
    }
  });

  // Derive project line counts on page load when not lazy loading
  if (!$body.find('#category-filter').data('load-counts-url')) {
    setProjectLineCounts($body);
  }
};
